import _ from "lodash";
import {atom} from "jotai";
import {loadObjectFromStorage, saveObjectToLocalStorage} from "../services/localStorageService";
import {FieldChartType} from "../types/fieldChart";

const LOCAL_STORAGE_SELECTED_FIELD_CHARTS = "selectedFieldCharts";

const loadSelectedFieldCharts = (): FieldChartType[] => {
    const storedValue = loadObjectFromStorage(LOCAL_STORAGE_SELECTED_FIELD_CHARTS, {charts: []});

    return Array.isArray(storedValue?.charts)
        ? (_.intersection(storedValue.charts, Object.values(FieldChartType)) as FieldChartType[])
        : [];
};

const selectedFieldChartsPrimitiveAtom = atom<FieldChartType[]>(loadSelectedFieldCharts());

export const selectedFieldChartsAtom = atom<FieldChartType[], [FieldChartType[]], void>(
    (get) => get(selectedFieldChartsPrimitiveAtom),
    (_get, set, selectedCharts) => {
        set(selectedFieldChartsPrimitiveAtom, selectedCharts);
        saveObjectToLocalStorage(LOCAL_STORAGE_SELECTED_FIELD_CHARTS, {charts: selectedCharts});
    },
);
